import { http } from "./http";

export const googleGeocodingApi = {
  async getAddressByCoordinates(latitude, longitude) {
    const response = await http.get("/google-geocode/reverse", {
      params: { latitude, longitude },
    });

    return response.data.data;
  },

  async getCoordinatesByAddress(address) {
    const response = await http.get("/google-geocode/forward", {
      params: { address },
    });

    return response.data.data;
  },
};